import { Component } from '@angular/core';

@Component({
  selector: 'app-header-activity-title',
  standalone: true,
  imports: [],
  templateUrl: './header-activity-title.component.html',
  styleUrl: './header-activity-title.component.scss'
})
export class HeaderActivityTitleComponent {

}
